import React from 'react';

const ServiceSection = ({ title, children, className = "" }) => {
  return (
    <section className={`service-section ${className}`}>
      <div className="container-modern">
        {title && <h2 className="service-section-title">{title}</h2>}
        <div className="service-section-content">
          {children}
        </div>
      </div>
    </section>
  );
};

export default ServiceSection;
